import environment from '@/environment'
import type { ControllerDescription } from '@/features/controller/types'
import type { Site } from '@/features/site/types/site'

export function getElectricianUiBaseUrl(site: Site) {
  return `https://${site.location}.${environment.legacyUiBaseDomain}/electrician/`
}

export function getElectricianViewUrl(site: Site, controller: ControllerDescription) {
  const electricianUIBaseUrl = getElectricianUiBaseUrl(site)

  if (controller.equipmentNumber) {
    return `${electricianUIBaseUrl}#resource-owners/uuid/${site.uuid}/electrician-view?search=${controller.equipmentNumber}`
  } else {
    return `${electricianUIBaseUrl}#resource-owners/uuid/${site.uuid}/electrician-view`
  }
}
